import { TBetItem } from '@/apis/commonSports/types';
import { EFbOddsFormatType } from '../common/constants/enum';
import { EFbSelectionType } from '../common/constants/selectionType';
import { reserveBetFb, TReserveBetParams } from './reserveBet';

export const placePreBetFb = async ({ betItem }: { betItem: TBetItem }) => {
  try {
    const params: TReserveBetParams = {
      unitStake: +betItem.betAmount,
      betOptionList: [
        {
          marketId: +betItem.marketId,
          optionType: betItem.fb?.ty as EFbSelectionType,
          odds: +(betItem.preBetInfo?.preBetOdds ?? 0),
          oddsFormat: EFbOddsFormatType.Europe,
        },
      ],
    };
    const res = await reserveBetFb(params);
    return res;
  } catch (error) {
    console.log('js---placePreBetFb error', error);
    return null;
  }
};
